"use client";

import React, { useState, useEffect } from "react";
import { Modal } from "react-bootstrap";
import { deleteScreenshots } from "../../../api/api";

const ScreenshotGallery = ({ screenshots }) => {
  const [usersScreenshots, setUsersScreenshots] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedImages, setSelectedImages] = useState([]);



  useEffect(() => {
    console.log("Gallery received screenshots:", screenshots);
    if (!screenshots?.length) {
      setUsersScreenshots([]);
      return;
    }

    const grouped = {};
    screenshots.forEach((item) => {
      if (!item.image) return;
      if (!grouped[item.user_id]) {
        grouped[item.user_id] = {
          userId: item.user_id,
          userName: item.userName,
          images: [],
        };
      }
      grouped[item.user_id].images.push({
        url: item.image,
        created_at: item.created_at,
        id: item.id, // important for deletion
      });
    });

    const result = Object.values(grouped).map((user) => ({
      ...user,
      images: user.images.sort(
        (a, b) => new Date(b.created_at) - new Date(a.created_at)
      ),
    }));

    setUsersScreenshots(result);
  }, [screenshots]);

  const handleDelete = async () => {
  if (!selectedImages.length) return;

  try {
    await deleteScreenshots(selectedImages);

    setUsersScreenshots((prev) =>
      prev.map((user) => ({
        ...user,
        images: user.images.filter((img) => !selectedImages.includes(img.id))
      }))
    );

    setSelectedImages([]);
  } catch (err) {
    console.error("Delete failed", err);
  }
};

  return (
    <>


      {!usersScreenshots.length ? (
        <div className="text-muted">No screenshots found</div>
      ) : (
        <div className="d-flex flex-wrap gap-3">
          {usersScreenshots.map((user) => (
            <div key={user.userId} className="text-center">
              <img
                src={user.images[0].url}
                alt={user.userName}
                className="rounded-3"
                style={{
                  width: 220,
                  height: 130,
                  objectFit: "cover",
                  cursor: "pointer",
                }}
                onClick={() => setSelectedUser(user)}
              />
              <div className="mt-2 fw-semibold">{user.userName}</div>
            </div>
          ))}
        </div>
      )}

      <Modal
        show={!!selectedUser}
        onHide={() => setSelectedUser(null)}
        size="lg"
        centered
      >
        <Modal.Header closeButton>
  <Modal.Title>{selectedUser?.userName} Screenshots</Modal.Title>

  {selectedImages.length > 0 && (
    <button
      className="btn btn-danger ms-auto"
      onClick={handleDelete}
    >
      Delete Selected ({selectedImages.length})
    </button>
  )}
</Modal.Header>

        <Modal.Body className="d-flex flex-wrap gap-2">
          {selectedUser?.images.map((img) => {
            const isSelected = selectedImages.includes(img.id);

            return (
              <div
  key={img.url}
  className="position-relative"
  style={{ display: "inline-block" }}
>
  <img
    src={img.url}
    alt=""
    className={`rounded-2 ${isSelected ? "border border-primary border-3" : ""}`}
    style={{ width: 220, height: 130, objectFit: "cover", cursor: "pointer" }}
    onClick={() => {
      if (isSelected) {
        setSelectedImages(selectedImages.filter((id) => id !== img.id));
      } else {
        setSelectedImages([...selectedImages, img.id]);
      }
    }}
  />

  {/* ✅ Capture Date */}
  <div style={{ fontSize: 12, marginTop: 4, textAlign: "center" }}>
    {new Date(img.created_at).toLocaleString()}
  </div>

  {isSelected && (
    <div
      className="position-absolute top-0 start-0 bg-primary text-white rounded-circle d-flex align-items-center justify-content-center"
      style={{ width: 24, height: 24, margin: 4 }}
    >
      ✓
    </div>
  )}
</div>
            );
          })}
        </Modal.Body>
      </Modal>
    </>
  );
};

export default ScreenshotGallery;